import { createSlice } from '@reduxjs/toolkit';
import { ConfigurationState } from '../../interfaces/configuration.interface';

const initialState: ConfigurationState = {
  settings: {
    language: {
      name: '',
      code: '',
    },
    currency: {
      name: '',
      code: '',
      value: 0,
    },
    colorScheme: {
      primary: '#2B3493',
      secondary: '#FB9E3B',
      highlight: '#414CC8',
    },
    firstLogin: true,
    darkMode: false,
  },
  api: {
    token: '',
  },
};

export const ConfigurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    resetStateConfiguration: () => {
      return initialState;
    },
    setDarkMode: (state, action) => {
      state.settings.darkMode = action.payload;
    },
  },
});

export default ConfigurationSlice.reducer;

// Add all of the reducers to the export below
export const { resetStateConfiguration, setDarkMode } =
  ConfigurationSlice.actions;
